import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "h1",
  "use": "h1-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"h1\"><path d=\"M6.25 1.5h1v3.75h-4.5V1.5h1V0H.25v1.5h1v9h-1V12h3.5v-1.5h-1V6.75h4.5v3.75h-1V12h3.5v-1.5h-1v-9h1V0h-3.5zM13 11V6h-1.5v1h.5v4h-1v1h3v-1z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol